import { EpimsBaseEntityDto } from './epim-base.dto';
export class IssuedCategoryDto extends EpimsBaseEntityDto {

    IssuedCategoryId: string;

    IssuedCategoryName: string;

    SubscriptionUserId: string;
    
    length : number;
    
    Version: number;

}